import React, { useRef } from 'react';
import { FaMapMarker } from "react-icons/fa";
import { colors } from 'utils';

const Carousel = ({ destinations, getDetails, tripSelected }) => {
  const carouselRef = useRef(null);

  const scrollCarousel = (scrollOffset) => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({
        left: scrollOffset,
        behavior: 'smooth',
      });
    }
  };

  return (
    <div className="relative my-4">
      <button
        className="w-10 h-10 absolute left-0 top-1/2 transform -translate-y-1/2 bg-gray-800 text-white p-2 rounded-full z-10 hover:bg-gray-600"
        onClick={() => scrollCarousel(-200)}
      >
        ◀
      </button>

      <div
        className="flex flex-row overflow-x-auto gap-4 scrollbar-hide pl-12"
        ref={carouselRef}
      >
        {
          destinations.map((item, index) => (
            <div
              className={`h-10 w-96 ${item.id === tripSelected ? "bg-gray-500" : colors[item.status] ?? 'bg-red-400' } flex-shrink-0 flex justify-center items-center gap-3 text-white text-xs font-semibold px-4 py-1 rounded-lg cursor-pointer hover:scale-105 transition-transform`}
              key={index}
              onClick={() => getDetails(item.id)}
              style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
            >
              <FaMapMarker /> {item.loadId} - {item.shipTo} {item.shipToName}
            </div>
          ))
        }
      </div>

      <button
        className="w-10 h-10 absolute right-0 top-1/2 transform -translate-y-1/2 bg-gray-800 text-white p-2 rounded-full z-10 hover:bg-gray-600"
        onClick={() => scrollCarousel(200)}
      >
        ▶
      </button>
    </div>
  );
};

export default Carousel;